export default __webpack_public_path__ + "static/media/food-1.3e1ecc86.png";